// @ts-nocheck
import React from 'react';
import { InsightsChart, LoadingSkeleton } from 'sonata-react-components';

import { useReportingEventsChart } from './useReportingEventsChart';

type Props = {
  cids: string[];
  country: string;
  disaggregated: string;
  disaggregatedBy?: string;
  graphLabel: string;
  groupBy: string;
  hideKpis?: boolean;
  metricsKpis: {
    kpi?: {
      id: string;
      label: string;
    };
    metric: {
      id: string;
      label: string;
    };
  };
  showAllLegend?: boolean;
  timezone?: string;
};

const ReportingEventsChart: React.VFC<Props> = ({
  cids,
  country,
  disaggregated,
  disaggregatedBy,
  graphLabel,
  groupBy,
  hideKpis = false,
  metricsKpis,
  showAllLegend = false,
  timezone = 'UTC'
}) => {
  const { chartConfig, configStats, kpiStatsStatus } = useReportingEventsChart({
    cids,
    country,
    disaggregated,
    disaggregatedBy,
    groupBy,
    hideKpis,
    metricsKpis,
    showAllLegend,
    timezone
  });

  return (
    <div className="insightsEventsChart">
      <div className="subtitleDefault fontSemiBold alignLeft insightsEventsChart__label">{graphLabel}</div>
      {configStats && (kpiStatsStatus === 'finished' || kpiStatsStatus === 'error') ? (
        <InsightsChart
          chartConfig={chartConfig}
          key={`insightsEventsChart__${disaggregated}__${showAllLegend}`}
          loading={false}
        />
      ) : (
        <div className="insightsEventsChart__skeleton">
          <LoadingSkeleton count={8} delay={2} duration={2} height="40px" width="100%" />
        </div>
      )}
    </div>
  );
};

export default React.memo(ReportingEventsChart);
